import { Design, PixelDesign, VectorDesign } from '@/types';

export const isVectorDesign = (design: Design): design is VectorDesign => design.colors.length > 0;

export const isPixelDesign = (design: Design): design is PixelDesign => !isVectorDesign(design);

export const assertPixelDesign = (design: Design) => {
  if (isVectorDesign(design)) {
    throw new Error('Invalid design type');
  }

  return design;
};
